import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { StatusService } from 'pages/system-fields/statuses/service';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, creatTableButton } from 'resources/utility';
import toastr from 'toastr';

@inject(StatusService, DialogService, EventAggregator)
export class Statuses {
    constructor(statusService, dialogService, ea) {
        this.ea = ea;
        this.statusService = statusService;
        this.dialogService = dialogService;

        this.columns = [
            { dataField: 'name', sortOrder: 'asc', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { caption: 'Actions', cellTemplate: (container, options) => creatTableButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete }), allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('statuses:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (status) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.statusService.delete(status.id);
                this.grid.refresh();
                toastr.success('Status was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: this.statusService.editor });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.statusService.editor, model: { id: data.id } });
    };
}